import { createAsyncThunk } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { getApiBaseUrl } from '../../utils/utilityFunctions';
import { getCookieData } from '../../utils/cookieHandler/handler';
import createRestApiClient from '../../utils/createRestApiClient';
import { getEnvVar } from '../../utils/env';

export const fetchAccessibilityDetails = createAsyncThunk(
  'accessibility/fetchAccessibilityDetails',
  async (payload, { rejectWithValue }) => {
    const { shareId, queryParams } = payload;
    try {
      const mockApiEndpoint = `${getApiBaseUrl()}/accessibility/api/v1/automation/test-summary`;

      const mockApiClient = createRestApiClient().withConfig({
        baseURL: mockApiEndpoint,
      }).client;

      let headerToPass;
      if (shareId) {
        headerToPass = {
          'x-ml-auth': shareId,
          'x-ml-user': 'sharing-client',
        };
      } else {
        let cookieName = getEnvVar('REACT_APP_COOKIE_NAME');
        let accessToken = getCookieData(cookieName);
        headerToPass = { Authorization: `Bearer ` + accessToken };
      }

      const response = await mockApiClient.get(mockApiEndpoint, {
        headers: headerToPass,
        params: queryParams,
      });

      return response.data;
    } catch (error) {
      const errorMessage = get(
        error,
        ['response', 'data', 'message'],
        error.message || 'Failed to fetch accessibility details'
      );
      return rejectWithValue(errorMessage);
    }
  }
);
